"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.getCreativity = void 0;
const effects_1 = require("redux-saga/effects");
const next12_app_controller_reducers_sagas_custo_reducer_1 = require("@gcloud-npm/next12.app-controller.reducers-sagas.custo-reducer");
function* getCustomParamsWhenActivity(context) {
    try {
        let commonModule = yield (0, effects_1.call)(() => Promise.resolve().then(() => __importStar(require("@gcloud-npm/next12.utils.common"))));
        const urlParams = commonModule.getUrlParams(true, [
            /recomEnterprise/g,
            /percentile/g,
            /levCode/g,
            /prodCode/g,
            /promoCode/g,
            /ctz_c/g,
            /turingDev/g,
            /productOffering/g,
            /webCode/g,
            /context.*/g,
            /custoHost/g,
            /businessClusters/g,
            /recomType/g,
            /userType/g,
            /ctzTest/g,
        ]);
        const { subseg, gwIspI3D, gwIsp, userType, clientIDs, device, i3Ready, pageSegment, userPriority, creativitiesHistory, referalAP, userCUCFijoHash, userCUCMovilHash, userIdPartyHash, } = context;
        let custoObject = {
            i3Ready,
            SEG_NAV: pageSegment,
            i3_cuc: userCUCFijoHash,
            i3_cucm: userCUCMovilHash,
            i3_idp: userIdPartyHash,
            ga: clientIDs.ga,
            pageId: clientIDs.pageId,
            paid: clientIDs.sessId,
            ctz_c: "true",
            originUrl: window.location.href,
            context: {
                subseg,
                creativitiesHistory,
                gw_isp: gwIsp,
                gw_isp_d: gwIspI3D,
                isLogado: userType ? "true" : "false",
                tipoUsuario: userType,
                deviceType: device,
                seg_nav: pageSegment,
                isPriority: userPriority ? "true" : "false",
                referal_ap: referalAP,
            },
        };
        if (urlParams.context && typeof urlParams.context === "object") {
            urlParams.context = Object.assign(Object.assign({}, custoObject.context), urlParams.context);
        }
        custoObject = Object.assign(Object.assign({}, custoObject), urlParams);
        return custoObject;
    }
    catch (e) {
        throw new Error(e);
    }
}
function* getCreativity({ data }) {
    try {
        let { kind } = data;
        if (!kind) {
            kind = "creativity";
        }
        let custoParams = {};
        let preRenderEnv = null;
        const { creativityId, build } = data;
        let getByName = yield (0, effects_1.call)(() => Promise.resolve().then(() => __importStar(require("./get-by-name"))));
        getByName = getByName.default;
        const context = yield (0, effects_1.select)((state) => state.main.context);
        if (!build) {
            custoParams = yield (0, effects_1.call)(getCustomParamsWhenActivity, context);
        }
        else {
            preRenderEnv = "movistar.es";
        }
        let response = null;
        response = yield (0, effects_1.call)(getByName, {
            context,
            build,
            preRenderEnv,
            name: creativityId,
            custoParams,
            kind,
        });
        // flipo.. en cada pc me responde un response type ?
        if (response && typeof response === "string") {
            response = JSON.parse(response);
        }
        yield (0, effects_1.put)(next12_app_controller_reducers_sagas_custo_reducer_1.actions.setCreativity({
            creativityId,
            info: response,
        }));
    }
    catch (err) {
        // console.log(err);
    }
}
exports.getCreativity = getCreativity;
exports.default = getCreativity;
//# sourceMappingURL=server.js.map